export type MedcallStaffOption = {
  email?: string | null;
  fullname?: string | null;
  id: number;
  username?: string | null;
};

const normalizeStaffValue = (value: unknown) => `${value || ''}`.trim();

export const getMedcallStaffOptionLabel = (option: MedcallStaffOption) => {
  const fullname = normalizeStaffValue(option.fullname) || `Staff ${option.id}`;
  const username = normalizeStaffValue(option.username);
  if (!username) {
    return fullname;
  }

  return `${fullname} (${username})`;
};

export const orderMedcallStaffOptions = (
  options: MedcallStaffOption[],
  routeBase: string,
) => {
  const orderedOptions = [...options];
  if (routeBase === '/tools/medcall2') {
    return orderedOptions;
  }

  return orderedOptions.sort((left, right) => {
    return getMedcallStaffOptionLabel(left).localeCompare(getMedcallStaffOptionLabel(right));
  });
};
